import { useEffect, useState } from 'react'

const CEP_LENGTH = 8

const useCepAutoComplete = (value, isEditing = true) => {
  const [data, setData] = useState({})
  const numberCep = value && value.replace(/[^0-9]+/g, '')

  useEffect(() => {
    let active = true

    const fetchCep = async () => {
      if (!numberCep || numberCep.length !== CEP_LENGTH || !isEditing) {
        if (active) setData({})
        return
      }

      // 1) ViaCEP
      try {
        const res = await fetch(`https://viacep.com.br/ws/${numberCep}/json/`)
        if (!res.ok) throw new Error(`viacep status ${res.status}`)
        const values = await res.json()
        if (values?.erro) throw new Error('viacep erro')

        const payload = {
          city: values.localidade,
          neighborhood: values.bairro,
          address: values.logradouro,
          cep: numberCep,
          state: values.uf,
        }
        if (active) setData(payload)
        return
      } catch (_) {
        // fall through to next provider
      }

      // 2) BrasilAPI
      try {
        const res2 = await fetch(`https://brasilapi.com.br/api/cep/v1/${numberCep}`)
        if (!res2.ok) throw new Error(`brasilapi status ${res2.status}`)
        const values2 = await res2.json()

        const payload = {
          city: values2.city,
          neighborhood: values2.neighborhood,
          address: values2.street,
          cep: numberCep,
          state: values2.state,
        }
        if (active) setData(payload)
        return
      } catch (_) {
        // fall through to next provider
      }

      // 3) AwesomeAPI CEP
      try {
        const res3 = await fetch(`https://cep.awesomeapi.com.br/json/${numberCep}`)
        if (!res3.ok) throw new Error(`awesomeapi status ${res3.status}`)
        const values3 = await res3.json()

        const payload = {
          city: values3.city,
          neighborhood: values3.district,
          address:
            values3.address ||
            [values3.address_type, values3.address_name].filter(Boolean).join(' '),
          cep: numberCep,
          state: values3.state,
        }
        if (active) setData(payload)
        return
      } catch (_) {
        // All providers failed
        if (active) setData({})
      }
    }

    fetchCep()

    return () => {
      active = false
    }
  }, [numberCep, isEditing])
  return data
}

export default useCepAutoComplete
